import React, { FC } from 'react'
import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'

export type EyeVals = { ref?: number; value?: number }
export type DetectionStatus = 'detected' | 'undetected' | 'unknown'

export const computeDetection = ({ dexter, sinister }: { dexter: EyeVals; sinister: EyeVals }): DetectionStatus => {
  const allSinisterValuesAreNumbers = Number.isFinite(sinister?.value) && Number.isFinite(sinister?.ref)
  const allDexterValuesAreNumbers = Number.isFinite(dexter?.value) && Number.isFinite(dexter?.ref)

  if (!allSinisterValuesAreNumbers && !allDexterValuesAreNumbers) return 'unknown'
  return dexter.value! > dexter.ref! || sinister.value! > sinister.ref! ? 'detected' : 'undetected'
}

export const DetectionTag: FC<{ status: DetectionStatus }> = ({ status }) => {
  const { t } = useTranslation()
  if (status === 'detected') return <Tag color="#EA0B5C">{t('consultations.detected')}</Tag>
  if (status === 'undetected') return <Tag color="#07A55E">{t('consultations.undetected')}</Tag>
  return <Tag>—</Tag> // unknown / not enough data
}

export const ExaminationValueTag: FC<{ values: EyeVals; side: 'dexter' | 'sinister' }> = ({ values, side }) => {
  const { ref, value } = values
  const sideIndicator = side === 'dexter' ? 'R: ' : 'L: '
  if (!value || !ref || !Number.isFinite(value) || !Number.isFinite(ref)) return <Tag>—</Tag>
  return value > ref ? <Tag color="#EA0B5C">{sideIndicator + value.toFixed(3)}</Tag> : <Tag color="#07A55E">{sideIndicator + value.toFixed(3)}</Tag>
}
